import styled from 'styled-components';

export const ProfileLogo = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 22px;
  background: ${({ $src }) => $src ? `url(${$src})` : 'linear-gradient(135deg, var(--vo-escuro), var(--vo-cobalto))'};
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Rubik', sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
`;
